import { createSelector } from 'reselect';

// @ts-expect-error not migrated to ts
import { getIsProOrEnterprise } from 'EmailData/selectors/user';
export const hasComparisonToolAccess = createSelector([getIsProOrEnterprise], isProOrEnterprise => isProOrEnterprise);
export const getComparisonToolReturnLocation = state => state.get('comparisonToolReturnLocation');